import { Flex, Label, layout, Span, styled } from '@fareye/ui'
import React from 'react'

export const ColFullHeight = styled((props: any) => (
  <Flex
    p={2}
    justifyContentSpaceEvenly
    alignItemsFlexStart
    column
    {...props}
    style={{ height: '100%', overflow: 'hidden' }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`
export const InputLabel = styled(Label)`
  margin-bottom: 4px;
  ${(props: any) => `
    color: ${props.theme.colors.gray9};
  `}
  ${(props: any) => props.style}
`
export const AlertType = styled(Span)`
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 0px;
  ${(props: any) => `
    color: ${props.variant.includes('primary') ? '' : props.theme.colors.gray7};
    border-right: ${
      props.variant.includes('primary') ? '2px solid rgba(24,144,255)' : 'unset'
    };
  `}
`

export const configManagementStyle = {
  groupedButton: {
    width: 91,
    justifyContent: 'center'
  }
}

export const ClientListing: any = styled(Flex)`
  padding: 0 5px;
  > span {
    margin: 2px;
    position: relative;
    max-width: 250px;
    flex-grow: 1;
    padding: 4px 26px 4px 4px;
    display: block;
    background: #e2e2e2;
    &::after {
      content: 'x';
      display: block;
      position: absolute;
      background: #ffa4a4;
      padding: 4px 9px 4px 9px;
      right: 0;
      top: 0;
    }
  }
`
